/* eslint-disable no-lonely-if */
/* eslint-disable no-nested-ternary */
import { mapValues, remove, uniq } from 'lodash';
import {
  checkSubqchoices,
  hasNodeValue,
  isSubqchoice,
  updateStructure,
} from '@mummssoftware/utils/form-engine/form-engine-utils';
import { Other } from './constants';
import defaults from '../../translations/en.json';

/**
 * create form data on initial load
 */
export const createFormData = (formData: any) => {
  // would parsedData ever be null?
  const planData =
    formData?.formsubmission ||
    formData?.formsubmissionautosave ||
    formData?.formdefinition;
  let parsedData: any = null;
  // catch JSON parse exceptions

  try {
    parsedData = planData && JSON.parse(planData);
  } catch (e) {
    // TODO alert
    console.log('JSON PARSING ERROR', e);
  }

  // todo find better way than updatedData?

  const updatedData = parsedData ? updateStructure(parsedData) : null;
  return updatedData;
};

/**
 * renderTreeStructure - NOT USED
 */

export const renderTreeStructure = (inputs: any, depthLevel = 0) => {
  const menuTree = inputs.reduce((seed: any, val: any) => {
    const hasOptions = checkSubqchoices(val);

    let subMenu;
    if (hasOptions) {
      const newDepthLevel = depthLevel + 1;

      subMenu = renderTreeStructure(val.subqchoices, newDepthLevel);
      seed[val.id] = subMenu;
    } else {
      seed[val.id] = {};
    }
    return seed;
  }, {} as any);

  return menuTree;
};

/**
 * creates initGroupBoxStateData
 */

export const createInitState = (data: any) =>
  data
    ? data.reduce((seed: any, val: any) => {
        if (val.questionpath) {
          if (seed[val.parentquestionpath]) {
            seed[val.parentquestionpath][val.questionpath] = false;
          } else {
            seed[val.parentquestionpath] = {
              [val.questionpath]: false,
            };
          }
        }
        return seed;
      }, {} as Record<string, Record<string, boolean>>)
    : null;

/**
 * creates initEditGroupBoxStateData for the editing version
 */

export const createEditInitState = (data: any, initseed: any) =>
  data
    ? data.reduce((seed: any, val: any) => {
        // hasValue is a boolean
        const hasValue =
          isSubqchoice(val) ||
          (typeof val.value === 'string' && val.value !== 'false');
        if (hasValue) {
          // value for text input
          const value = isSubqchoice(val) ? true : val.value;
          const isText = !isSubqchoice(val);
          if (seed[val.parentquestionpath]) {
            seed[val.parentquestionpath][val.questionpath] = value;
            if (isText) {
              seed[val.questionpath] = value;
            } else {
              seed[val.questionpath] = {};
            }
            if (checkSubqchoices(val)) {
              createEditInitState(val.subqchoices, seed);
            }
          } else {
            seed[val.parentquestionpath] = {
              [val.questionpath]: value,
            };
            seed[val.questionpath] = {};
            if (checkSubqchoices(val)) {
              createEditInitState(val.subqchoices, seed);
            }
          }
        }
        return seed;
      }, initseed as Record<string, Record<string, boolean>>)
    : null;

export const createGolbalEditInitState = (data: any) =>
  createEditInitState(data, {});

/**
 * creates GolbalDCInitState for the editing version
 */

export const createDCInitState = (data: any, initseed: any) =>
  data
    ? data.reduce((seed: any, val: any) => {
        // hasDC is a boolean
        const hasDC = val.dcdate;
        if (hasDC) {
          seed[val.questionpath] = true;
        } else if (checkSubqchoices(val)) {
          createDCInitState(val.subqchoices, seed);
        }

        return seed;
      }, initseed as Record<string, Record<string, boolean>>)
    : null;

export const createGolbalDCInitState = (data: any) =>
  createDCInitState(data, {});

/**
 * creates createEditInitSubmitState for the editing version
 */

export const createEditInitSubmitState = (data: any) => {
  if (data && Object.keys(data).length) {
    const seed: any = {};
    Object.keys(data).forEach((key) => {
      if (typeof data[key] === 'string') {
        seed[key] = data[key];
      } else {
        seed[key] = true;
      }
    });
    return seed;
  }
  return null;
};

/**
 * creates initSubmitGroupBoxState
 */

export const createInitSubmitState = (data: any) =>
  data
    ? data.reduce((seed: any, val: any) => {
        if (val.questionpath) {
          seed[val.parentquestionpath] = false;
        }
        return seed;
      }, {} as Record<string, boolean>)
    : null;

/**
 * creates initial ID array for the editing version
 */

const createInitIds = (data: any, initseed: any, depthLevel = 0) =>
  data
    ? data.reduce((seed: any, val: any) => {
        // hasValue is a boolean
        const hasValue =
          isSubqchoice(val) ||
          (typeof val.value === 'string' && val.value !== 'false');
        if (hasValue) {
          if (seed[depthLevel]) {
            seed[depthLevel].push(val.questionpath);
          } else {
            seed[depthLevel] = [val.questionpath];
          }
          if (checkSubqchoices(val)) {
            const newDepthLevel = depthLevel + 1;
            createInitIds(val.subqchoices, seed, newDepthLevel);
          }
        }
        return seed;
      }, initseed as Record<string, Record<string, boolean>>)
    : null;

export const createGlobalInitIds = (data: any) => createInitIds(data, []);

/**
 * create Single Parent Question Path
 */
const createParentQuestionPath = (path: string) => {
  const arr: string[] = [];
  arr.push(path);
  const pathArr = path.split('->');
  for (let step = 1; step < pathArr.length; step++) {
    const parentPath = pathArr.slice(0, -step);
    arr.push(parentPath.join('->'));
  }
  return arr;
};
/**
 * create All Parent Question Path
 */
const createAllParentQuestionPath = (keys: string[]) => {
  const allParentPaths = keys.reduce((seed: any, value: string) => {
    const parentPath = createParentQuestionPath(value);
    const newSeed = seed.concat(parentPath);
    return newSeed;
  }, []);

  const uniqParentPath = uniq(allParentPaths);
  return uniqParentPath;
};

/**
 * remove false node- in case you toggle a checkbox, true to false
 */
const cleanDiffState = (state: Record<string, any>) => {
  const cleanedState = Object.entries(state).reduce((seed: any, arr: any[]) => {
    const key = arr[0];
    const value = arr[1];
    if (value && value !== 'false') {
      seed[key] = value;
    }
    return seed;
  }, []);
  return cleanedState;
};
/**
 * create the Diff State
 */
const createDiffState = (state: Record<string, any>) => {
  const cleanState = cleanDiffState(state);
  const keyState = Object.keys(cleanState);
  if (Object.keys(keyState).length) {
    const keyParents = createAllParentQuestionPath(keyState);
    const parentState: any = keyParents.reduce((seed: any, value: any) => {
      seed[value] = true;
      return seed;
    }, {});
    const updatedState = { ...parentState, ...cleanState };
    return updatedState;
  }
  return {};
};
/**
 * create the Preview State- Difference init and actual
 */
export const createPreviewState = (
  initState: Record<string, any>,
  submitState: Record<string, any>,
) => {
  const initSubmitKeys = Object.keys(initState);
  initSubmitKeys.forEach((key: string) => {
    if (initState[key] === submitState[key]) {
      delete submitState[key];
    }
  });
  const previewState = createDiffState(submitState);
  return previewState;
};
/**
 * create the Diff DC state
 */
export const createDCState = (
  initState: any, // Record<string, any> - if no value = {}
  dcState: any, // Record<string, any> | null - dcState can be bull
) => {
  if (initState && dcState) {
    const initSubmitKeys = Object.keys(initState);
    if (initSubmitKeys.length) {
      initSubmitKeys.forEach((key: string) => {
        delete dcState[key];
      });
    }
    return Object.keys(dcState).length ? dcState : null;
  }
  return null;
};
/**
 * create the Preview DC State- Difference init and actual
 */
export const createPreviewDCState = (
  initState: any, // Record<string, any> - if no value = {}
  dcState: any, // Record<string, any> | null - dcState can be bull
) => {
  if (initState && dcState) {
    const initSubmitKeys = Object.keys(initState);
    if (initSubmitKeys.length) {
      initSubmitKeys.forEach((key: string) => {
        delete dcState[key];
      });
    }
    const keySubmitState = Object.keys(dcState);
    if (keySubmitState.length) {
      const keyParents = createAllParentQuestionPath(keySubmitState);
      const parentState: any = keyParents.reduce((seed: any, value: any) => {
        seed[value] = true;
        return seed;
      }, {});
      return parentState;
    }
    return null;
  }
  return {};
};

/**
 * update an item with specific ID in a tree structure
 * returns the tree structure
 */

export const updateElement = (obj: any, questionpath: any, state: any): any =>
  Array.isArray(obj)
    ? obj.map((o) => updateElement(o, questionpath, state))
    : obj.questionpath === questionpath
    ? {
        ...obj,
        value: state[questionpath],
      } // found it and update value
    : {
        ...obj,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateElement(obj.subqchoices, questionpath, state),
            }
          : {}),
      };

/**
 * updateElementBis(newData, submitkey, submitGroupBoxState);
 * update an item with specific questionpath in the tree structure
 * used to update each item in the SUBMIT state
 * returns the tree structure updated with the SUBMIT state
 */
export const updateElementBis = (
  obj: any,
  questionpath: any,
  state: any,
  // eslint-disable-next-line consistent-return
): any => {
  let newObj: any;
  if (Array.isArray(obj)) {
    newObj = obj.map((o) => updateElementBis(o, questionpath, state));
  } else {
    // item found, return updated item, stop recursion
    if (obj.questionpath === questionpath) {
      // if item was previously DC
      if (state[questionpath] === true && obj.dcdate) {
        if (checkSubqchoices(obj)) {
          // then unDC the children
          const childObj = {
            ...obj,
            value: state[questionpath],
            dcdate: null,
            // update all the children dcdate to NULL
            subqchoices: updateAllChildrenDCDatetoNull(obj.subqchoices),
          };
          return childObj;
        }
        const childObj = {
          ...obj,
          value: state[questionpath],
          dcdate: null,
        };
        return childObj;
      }
      // update the item
      const childObj = {
        ...obj,
        value: state[questionpath],
      };
      return childObj;
    }
    // recursion keep happening
    const childObj = {
      ...obj,
      ...(checkSubqchoices(obj)
        ? {
            subqchoices: updateElementBis(obj.subqchoices, questionpath, state),
          }
        : {}),
    };
    return childObj;
  }
  return newObj;
};

/**
 * update an item with specific ID in a tree structure that has been dc
 */

export const updateDCElement = (
  obj: any,
  questionpath: any,
  date: string,
): any =>
  Array.isArray(obj)
    ? obj.map((o) => updateDCElement(o, questionpath, date))
    : obj.questionpath === questionpath
    ? { ...obj, dcdate: date } // found it and update dcdate
    : {
        ...obj,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateDCElement(obj.subqchoices, questionpath, date),
            }
          : {}),
      };
/**
 * update an item with specific ID in a tree structure that has been edited
 */
// NOT USED

export const updateEditEffDateElement = (
  obj: any,
  questionpath: any,
  date: string,
): any =>
  Array.isArray(obj)
    ? obj.map((o) => updateEditEffDateElement(o, questionpath, date))
    : obj.questionpath === questionpath
    ? { ...obj, effectivedate: date } // found it and update effective date
    : {
        ...obj,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateEditEffDateElement(
                obj.subqchoices,
                questionpath,
                date,
              ),
            }
          : {}),
      };

/**
 * update all Tree nodes to value false
 */

const updateAllChildrenElementToFalse = (obj: any): any =>
  Array.isArray(obj)
    ? obj.map((o) => updateAllChildrenElementToFalse(o))
    : {
        ...obj,
        value: false,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateAllChildrenElementToFalse(obj.subqchoices),
            }
          : {}),
      };

/**
 * find when a node is false, update all children node to false,
 */

const hasNodeNoValue = (obj: any) =>
  obj.value === false || obj.value === 'false';

export const updateFalseNodes = (obj: any): any =>
  Array.isArray(obj)
    ? obj.map((o) => updateFalseNodes(o))
    : hasNodeNoValue(obj)
    ? {
        ...obj,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateAllChildrenElementToFalse(obj.subqchoices),
            }
          : {}),
      }
    : {
        ...obj,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateFalseNodes(obj.subqchoices),
            }
          : {}),
      };

/**
 * create a clean form with only false value - instead of an API call
 */
export const reinstateForm = (obj: any): any =>
  Array.isArray(obj)
    ? obj.map((o) => reinstateForm(o))
    : hasNodeValue(obj)
    ? {
        ...obj,
        value: false,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateAllChildrenElementToFalse(obj.subqchoices),
            }
          : {}),
      }
    : {
        ...obj,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: reinstateForm(obj.subqchoices),
            }
          : {}),
      };

/**
 * update all Tree nodes to dcdate
 */

const updateAllChildrenDCElement = (obj: any, date: string): any =>
  Array.isArray(obj)
    ? obj.map((o) => updateAllChildrenDCElement(o, date))
    : {
        ...obj,
        dcdate: date,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateAllChildrenDCElement(obj.subqchoices, date),
            }
          : {}),
      };

/**
 * update all nodes with null dcdate
 */

const updateAllChildrenDCDatetoNull = (obj: any): any =>
  Array.isArray(obj)
    ? obj.map((o) => updateAllChildrenDCDatetoNull(o))
    : {
        ...obj,
        dcdate: null,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateAllChildrenDCDatetoNull(obj.subqchoices),
            }
          : {}),
      };

/**
 * find when a node dcdate is true and update all children with dc date
 */

export const updateChildDCNodes = (obj: any, date: string): any =>
  // the first one if the main array and dcdate is null for those [{Related},{Goal},{Interventions}]
  Array.isArray(obj)
    ? // each object - main 3 objects - Related - Goal - Interventions
      obj.map((o) => updateChildDCNodes(o, date))
    : obj.dcdate !== null
    ? {
        ...obj,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateAllChildrenDCElement(obj.subqchoices, date),
            }
          : {}),
      }
    : {
        ...obj,
        ...(checkSubqchoices(obj)
          ? {
              subqchoices: updateChildDCNodes(obj.subqchoices, date),
            }
          : {}),
      };

/**
 * delete items that have been unselected
 */

const deleteElement = (obj: any, questionpath: string): any => {
  Object.keys(obj[questionpath]).length &&
    Object.keys(obj[questionpath]).forEach((childPath: string) => {
      if (obj[childPath]) {
        deleteElement(obj, childPath);
        delete obj[childPath];
      }
    });
  delete obj[questionpath];
  return obj;
};

export const unselectElement = (obj: any, questionpath: string): any => {
  obj[questionpath] = mapValues(obj[questionpath], () => false);
  deleteElement(obj, questionpath);
};

/**
 * unselect Id
 */

export const unselectId = (
  updatedArray: any,
  depthLevel: number,
  questionpath: string,
): any => {
  // for all level downs, splice it if includes questionpath
  for (
    let level: number = depthLevel + 1;
    level < updatedArray.length;
    level++
  ) {
    const hasLevel = updatedArray[level] && updatedArray[level].length;
    if (hasLevel) {
      const toRemove: any = [];
      updatedArray[level].forEach((path: string) => {
        if (path.includes(questionpath)) {
          toRemove.push(path);
        }
      });
      toRemove.length &&
        remove(updatedArray[level], (n) => toRemove.includes(n));
    }
  }
  return updatedArray;
};

/**
 * NOT USED - clean edit state
 */
export const cleanEditState = (state: any) => {
  const editArr = Object.keys(state);
  const toRemoveArr: any = [];
  for (let i = 0; i < editArr.length; i++) {
    const copyArr = [...editArr];
    copyArr.splice(i, 1);
    const checkPath = editArr[i];

    copyArr.forEach((path: string) => {
      if (path.includes(checkPath)) {
        toRemoveArr.push(checkPath);
      }
    });
  }

  toRemoveArr.forEach((path: string) => {
    delete state[path];
  });
  return state;
};

/**
 * clean submitted state
 */

export const cleanSubmittedState = (state: any, path: string) => {
  // delete future children
  const newPath = `${path}->`;
  const keys = Object.keys(state);
  keys.forEach((key) => {
    if (key.includes(newPath)) {
      delete state[key];
    }
  });
  return state;
};

/**
 * clean submitted state for DCing an item
 * case scenario is
 * an element is already selected down a list
 * you DC the parent element
 * you unDC the parent element and select another child item
 * you need the previous child item to be gone and the new one selected
 */

export const cleanSubmittedStateforDC = (state: any, path: string) => {
  // delete future children
  const newPath = `${path}->`;
  const keys = Object.keys(state);
  keys.forEach((key) => {
    if (key.includes(newPath)) {
      state[key] = false;
    }
  });
  return state;
};

/**
 * find radio parent
 */

export const getRadioParent = (parseddata: any, parentQuestionPath: string) => {
  const ids = parentQuestionPath.split('->');
  // if there is length
  // we assume first items cannot be radio as no parent component
  const steps = ids.length - 1;
  if (steps > 0) {
    // initial ID
    const initialID = `${ids[0]}->${ids[1]}`;
    // first item is not through subqchoices
    const initialObj = parseddata.filter(
      (data: any) => data.questionpath === initialID,
    );

    const getChildPath = (id: string, level: number, obj: any): any => {
      const newId = `${id}->${ids[level]}`;

      const recObj = obj[0].subqchoices.filter(
        (data: any) => data.questionpath === newId,
      );
      if (level < steps) {
        return getChildPath(newId, level + 1, recObj);
      }
      return recObj[0];
    };

    if (steps > 1) {
      const newLevel = 2;
      return getChildPath(initialID, newLevel, initialObj);
    }
    return initialObj[0];
  }
  return null;
};

/**
 * find all controltypes in the tree structure
 */

function flatten(ops: any, n: any) {
  ops.push(n.controltype);
  if (checkSubqchoices(n)) {
    [].reduce.call(n.subqchoices, flatten, ops);
  }
  return ops;
}

// const node = JSON.parse(option.formdefinition);

export const getAllTypes = (node: any) => node.reduce(flatten, []);

/**
 * find input for the Other Dropdown Option
 */
export const getOtherOption = (subqchoice: any) => {
  const { subqchoices } = subqchoice;
  const otherChoice =
    subqchoices && subqchoices.length > 1
      ? subqchoices.filter((choice: any) => choice.questionlabel === Other)[0]
      : null;

  const hasOtherValue = otherChoice ? checkSubqchoices(otherChoice) : null;
  const otherInput = hasOtherValue ? otherChoice.subqchoices[0] : null;
  return otherInput;
};
